import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

import { getDefaultHomePathForRoles } from "../../../Routes/roleAccess";

/**
 * Friendly upgrade prompt when a route requires a paid plan feature.
 * Never surfaces error.code / technical jargon (doc 14).
 */
const UpgradePlan = () => {
  const { t } = useTranslation();
  const homePath = getDefaultHomePathForRoles();

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6} className="text-center py-5">
            <div className="mb-3">
              <i className="ri-vip-crown-line display-4 text-warning" aria-hidden />
            </div>
            <h4 className="text-uppercase">{t("plan.upgrade.title")}</h4>
            <p className="text-muted mb-4">{t("plan.upgrade.description")}</p>
            <div className="d-flex flex-wrap gap-2 justify-content-center">
              <Link to="/settings/subscription" className="btn btn-primary">
                <i className="ri-rocket-line me-1" />
                {t("plan.upgrade.cta")}
              </Link>
              <Link to={homePath} className="btn btn-soft-secondary">
                <i className="ri-home-4-line me-1" />
                {t("plan.upgrade.backToHome")}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpgradePlan;
